package alltravelagents.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.features.travelagent.domain.model.TravelAgentModel
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun TravelAgentCommissionType(
    commissionType: TravelAgentModel.CommissionType?,
    suffixIconRes: String? = null,
    modifier: Modifier = Modifier,
) {
    val text = remember(commissionType) {
        when (commissionType) {
            TravelAgentModel.CommissionType.Net -> "Net"
            TravelAgentModel.CommissionType.Gross -> "Gross"
            else -> "Net"
        }
    }

    val esColorScheme = MaterialTheme.esColorScheme
    val color = remember(commissionType) {
        when (commissionType) {
            TravelAgentModel.CommissionType.Net -> esColorScheme.ghostPressed
            TravelAgentModel.CommissionType.Gross -> esColorScheme.ghostPressed
            else -> esColorScheme.ghostPressed
        }
    }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(1.spacing),
        modifier = modifier
            .background(color, CircleShape)
            .padding(
                vertical = 1.spacing,
                horizontal = 2.spacing,
            ),
    ) {
        Text(
            text = text,
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.p2Medium14,
        )

        suffixIconRes?.let {
            EsLargeIcon(
                res = it,
                tint = MaterialTheme.esColorScheme.iconPrimary,
            )
        }
    }
}